import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page16() {
  useEffect(() => {
    document.title = "Маяк — Страница 15"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page14" />
        <ForwardLink href="/page16" />
      </div>

      <p style={{ textAlign: "right" }}>15.</p>
      <p>МОЛОДОЙ машет рукой, пытаясь напугать ее.</p>
      <p>
        ЧАЙКА КРИЧИТ. Она поворачивает голову, открывая: ОТСУТСТВУЮЩИЙ<br/>
        ГЛАЗ. Пустая глазница ужасна и скрючена. Ранение в бою.
      </p>
      <p>МОЛОДОЙ неподвижно смотрит на странное уродство...</p>
      <p>ВНЕЗАПНО, ЧАЙКА ВЗМАХИВАЕТ КРЫЛЬЯМИ, НАБРАСЫВАЕТСЯ на него, щелкая клювом.</p>
      <p>Инстинктивно МОЛОДОЙ БРОСАЕТ в нее кусок угля...</p>
      <p>Он промахивается...</p>
      <p>
        На это раз ЧАЙКА мяукает, смотрит единственным глазом
        и улетает.
      </p>
      <p>МОЛОДОЙ наблюдает за полетом птицы...</p>
      <p>Она пролетает мимо маяка...</p>
      <p>
        СТАРИК смотрит на нее с ПОДИУМА БАШНИ<br/>
        (внешней смотровой площадки), попыхивая трубкой. Наблюдает.
      </p>
      <br/>
      <p>ВНУТРИ. МАЯК. КОТЕЛЬНАЯ – ДЕНЬ</p>
      <p>
        Двойные двери раскрываются, показывая: бочки с маслом<br/>
        внизу лестницы. <u>КОТЕЛЬНАЯ</u>. МОЛОДОЙ смотрит<br/>
        вверх...
      </p>
      <p><i>Это одна длинная лестница</i>.</p>
      <p>
        Цепи часового механизма маяка выглядят зловеще,<br/>
        свисая по центру железных спиральных ступеней,<br/>
        а их тени ползут по каменной стене. Они звенят<br/>
        и лязгают, создавая зловещее эхо...
      </p>
      <p>
        МОЛОДОЙ смотрит на БОЧКИ С МАСЛОМ, спрятанные под лестницей. Они<br/>
        гораздо больше и более внушительные, чем тяжелые мешки с мелом.
      </p>
      <br/>
      <p>ВНУТРИ. МАЯК. ЛЕСТНИЦА БАШНИ – ДЕНЬ</p>
      <p>Лязг. МОЛОДОЙ тащит огромную БОЧКУ С МАСЛОМ вверх по ступенькам.</p>
      <p>...</p>
      <p>...</p>
      <p>Лязг.</p>
      <p>...</p>
      <p>...</p>
      <p style={{ textAlign: "right" }}>15.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page14" />
        <ForwardLink href="/page16" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1708110907/the-lighthouse-script/hu84zo43w3b3rd3jueli.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page16;
